import { render, staticRenderFns } from "./GroupReward.vue?vue&type=template&id=4ee9edb6&"
import script from "./GroupReward.vue?vue&type=script&lang=js&"
export * from "./GroupReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports